import AService from '@/services/AService'

const ENTITY_NAME = 'lineId';

export default class LineIdService extends AService {
  async createLineId(data) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, data)
    return response.data
  }

  async import(file) {
    const formData = new FormData();
    formData.append('file', file)
    const response = await this.http.post(
      `${this.baseUrl}/${ENTITY_NAME}/import`,
      formData,
      {headers: {'Content-Type': 'multipart/form-data'}});
    return response.data
  }

  async updateLineId(data) {
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, data);
    return response.data
  }

  async fetchLineId(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }

  async fetchLinesPagingAndSorting(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }

  async getMainVenuesByLicencePeriods(licencePeriods) {
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/mainVenues`, licencePeriods)
    return response.data;
  }

  async deleteLineId(id) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${id}`)
    return response.data
  }

  async deleteMultipleLineId(ids) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}`, {data: ids})
    return response.data
  }

  async getSpectrumServicesByStakeholderId(stakeholderId) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/spectrum-services/${stakeholderId}`)
    return response.data
  }

  async getSpectrumServices() {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/spectrum-services`)
    return response.data
  }
}
